"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _Rule = _interopRequireDefault(require("./Rule"));

var _utils = require("./utils");

require("./rule-editor.css");

function makeRuleSetter(i, rules, setRules) {
  return function (value) {
    var newRules = (0, _toConsumableArray2.default)(rules);
    newRules[i] = value;
    setRules(newRules);
  };
}

function addRule(_ref) {
  var rule = _ref.rule,
      rules = _ref.rules,
      setRules = _ref.setRules,
      ruleBook = _ref.ruleBook,
      processors = _ref.processors;
  var defaultRule = (0, _utils.newRule)({
    rule: rule,
    ruleBook: ruleBook,
    processors: processors
  });
  setRules([].concat((0, _toConsumableArray2.default)(rules), [defaultRule]));
}

function _removeRule(i, rules, setRules) {
  var newRules = (0, _toConsumableArray2.default)(rules);
  newRules.splice(i, 1);
  setRules(newRules);
}

var RuleEditor = function RuleEditor(_ref2) {
  var ruleBook = _ref2.ruleBook,
      processors = _ref2.processors,
      _ref2$rules = _ref2.rules,
      rules = _ref2$rules === void 0 ? [] : _ref2$rules,
      setRules = _ref2.setRules,
      _ref2$RuleComponent = _ref2.RuleComponent,
      RuleComponent = _ref2$RuleComponent === void 0 ? _Rule.default : _ref2$RuleComponent;
  //console.log("RULES : ", rules);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "rule-editor-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "rule-editor"
  }, rules.map(function (rule, i) {
    return /*#__PURE__*/_react.default.createElement(RuleComponent, {
      key: i,
      ruleBook: ruleBook,
      processors: processors,
      rule: rule,
      setValues: makeRuleSetter(i, rules, setRules),
      removeRule: function removeRule() {
        return _removeRule(i, rules, setRules);
      }
    });
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "rule-editor-actions"
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    type: "primary",
    shape: "round",
    onClick: function onClick() {
      return addRule({
        rule: ruleBook[ruleBook.entry],
        rules: rules,
        setRules: setRules,
        ruleBook: ruleBook,
        processors: processors
      });
    }
  }, "Add Rule")));
};

var _default = RuleEditor;
exports.default = _default;